<div class="modal-content">
    <q-modal-header title="Add to Queue" (close)="onClose()" ></q-modal-header>
    <div class="modal-body p-3 pt-4">
        <div class="filters-form mt-1" *ngIf="!hideUsersInput">
            <app-remote-dropdown [filter]="userFilerConfig"
            [isIndividual]="true"
            (onChange)="onFiltersValueChange($event)"
            [config]="filtersConfig">
            </app-remote-dropdown>
        </div>
        <div class="filters-form mt-4">
            <app-remote-dropdown [filter]="productFilerConfig"
            [isIndividual]="true"
            (onChange)="onFiltersValueChange($event)"
            [config]="filtersConfig">
            </app-remote-dropdown>
        </div>
        <div class="filters-form mt-4 all-queues">
            <app-datepicker [filter]="filter.date" (onChange)="onDateChange($event)"></app-datepicker>
        </div>
        <div class="filters-form mt-4">
            <div class="input-group form-group-no-border filter-item d-flex">
                <label class="label text-end" [innerText]="filter.text.label"></label>
                <textarea class="pl-2 w-200px" rows="4" [(ngModel)]="additionalText"></textarea>
            </div>
        </div>
        <div class="filters-form mt-4 mb-2" *ngIf="!selectedProducts.length">
            <app-text-input [filter]="filter.queue_size" (onChange)="onQueueSizeChange($event)"></app-text-input>
        </div>
    </div>
    <div class="modal-footer py-2">
        <div class="d-flex justify-content-end">
            <button [disabled]="loading" class="btn btn-default me-2" (click)="onClose()">
                Close
            </button>
            <button [disabled]="isDisabledAddtoQueue()" class="btn btn-danger m-0" (click)="addToQueue()">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                Add to Queue(s)
            </button>
        </div>
    </div>
</div>